// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCDhRHjfWtyVUhs21jOq9_7Tb1blPZHYgg",
  authDomain: "bluehillleadgenerationtool.firebaseapp.com",
  projectId: "bluehillleadgenerationtool",
  storageBucket: "bluehillleadgenerationtool.firebasestorage.app",
  messagingSenderId: "309569868763",
  appId: "1:309569868763:web:666251a6e8505502330dfe"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;